import i18n from '@/i18n'

// 在非组件代码中使用的翻译函数
export function t(key: string, values = {}) {
  return i18n.global.t(key, values)
}
